import {
  ITrajectoryDetail,
  TrajectorySectionCode,
  TrajectoryViewMode,
} from '../../../config/api/models/Trajectory';
import { logWarning } from '../../shared';

export type NoSectionFoundError = 'noSectionFoundError';
export const NO_SECTION_FOUND_ERROR: NoSectionFoundError = 'noSectionFoundError';

export type SectionCodePending = 'sectionCodePending';
export const SECTION_CODE_PENDING: SectionCodePending = 'sectionCodePending';

const checkSectionCode = (
  sectionCode: TrajectorySectionCode,
  hasOpbouwContent: boolean,
  hasTheoryContent: boolean,
  hasExerciseContent: boolean,
  hasStudyCardContent: boolean
): TrajectorySectionCode | undefined => {
  let result: TrajectorySectionCode | undefined;

  switch (sectionCode) {
    case '0':
      if (hasOpbouwContent) result = '0';
      break;
    case '1':
      if (hasTheoryContent) result = '1';
      break;
    case '2':
      if (hasExerciseContent) return '2';
      break;
    case '3':
      if (hasStudyCardContent) return '3';
      break;
  }

  return result;
};

export const useSectionCodeToLoad = (
  trajectory: ITrajectoryDetail,
  viewMode: TrajectoryViewMode,
  sectionCode?: TrajectorySectionCode | undefined
): TrajectorySectionCode | null | NoSectionFoundError | SectionCodePending => {
  if (viewMode === 'edit' && !!sectionCode) return sectionCode;

  const hasOpbouwPage = !!trajectory.pages?.find(
    (page) => page.type === 'opbouw' && page.hasContent
  );
  const hasTheoryPage = !!trajectory.pages?.find(
    (page) => page.type === 'theory' && page.hasContent
  );
  const hasExercisePage = !!trajectory.pages?.find(
    (page) => page.type === 'worksheet_exercises' && page.hasContent
  );
  const hasStudyCardPage = !!trajectory.pages?.find(
    (page) => page.type === 'study_trainer' && page.hasContent
  );

  if (!!sectionCode) {
    // check if the given section is available
    const sectionCodeResult = checkSectionCode(
      sectionCode,
      hasOpbouwPage,
      hasTheoryPage,
      hasExercisePage,
      hasStudyCardPage
    );

    if (!!sectionCodeResult) return sectionCodeResult;
  }

  // if the given sectionCode did not result in a non-empty section, we continue to find the first non-empty section available
  // if no sectionCode was found, we continue to find the first non-empty section available
  if (hasOpbouwPage) return '0';
  if (hasTheoryPage) return '1';
  if (hasExercisePage) return '2';
  if (hasStudyCardPage) return '3';

  logWarning('No non-empty section was found in trajectory view mode.');

  return NO_SECTION_FOUND_ERROR;
};
